import loadable from '@loadable/component';
import Loading from '../components/Loader';

const Activate = loadable(
  () => import(/* webpackChunkName: "activate" */ '../containers/ShareableVoucherActivate'),
  { fallback: Loading }
);

export default Activate;
